// src/services/cspService.js
/**
 * Service to manage CSP nonce for script loading
 */
const cspService = {
  nonce: '',
  
  /**
   * Initialize the CSP nonce from the HTML meta tag
   */
  initialize: () => {
    try {
      // Get nonce from meta tag (should be set by the server)
      const metaNonce = document.querySelector('meta[name="csp-nonce"]');
      if (metaNonce) {
        cspService.nonce = metaNonce.getAttribute('content');
      } else {
        console.warn('CSP nonce meta tag not found');
        
        // Generate a fallback nonce (less secure, but better than nothing)
        cspService.nonce = btoa(Math.random().toString(36).substring(2, 15));
      }
    } catch (error) {
      console.warn('Failed to initialize CSP nonce:', error);
    }
  },
  
  /**
   * Get the current CSP nonce
   * @returns {string} The current CSP nonce
   */
  getNonce: () => {
    return cspService.nonce;
  },
  
  /**
   * Safely load an external script with CSP nonce
   * @param {string} src - Script source URL
   * @returns {Promise} - Resolves when script is loaded
   */
  loadScript: (src) => {
    return new Promise((resolve, reject) => {
      try {
        const script = document.createElement('script');
        script.src = src;
        script.nonce = cspService.getNonce();
        script.async = true;
        
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        
        document.head.appendChild(script);
      } catch (error) {
        reject(error);
      }
    });
  },
  
  /**
   * Safely execute inline JavaScript with CSP nonce
   * @param {Function} fn - Function to execute
   */
  executeScript: (fn) => {
    try {
      const script = document.createElement('script');
      script.nonce = cspService.getNonce();
      script.textContent = `(${fn.toString()})();`;
      
      document.head.appendChild(script);
      document.head.removeChild(script); // Clean up
    } catch (error) {
      console.warn('Failed to execute script:', error);
    }
  }
};

export default cspService;